module.exports = __webpack_public_path__ + "pfaeffikon.svg?343f5949316c9eeff8ab52b3879d9f4e";